import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import FilterFieldType from "../../../Domain/ReportBuilder/FilterFieldType";
import FilterConditionValueEntry from "./FilterConditionValueEntry";
import FilterColumnSelector from "./FilterColumnSelector";
import { filterOperators, isArgumentlessOperator, } from "../../../Domain/ReportBuilder/FilterOperator.model";
import StatusBadge from "../../UI/StatusBadge/StatusBadge";
import useConfirmation from "../../Hooks/useConfirmation";
const FilterConditionComponent = (props) => {
    var _a;
    // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    function onOperatorChangedInternal(event) {
        props.onOperatorChange(event.target.value);
        if (isArgumentlessOperator(event.target.value)) {
            props.isPromptChanged(false);
        }
    }
    // @ts-expect-error - TS7006 - Parameter 'selectedFilterSourceColumnId' implicitly has an 'any' type.
    function getSelectedFilterSourceColumn(selectedFilterSourceColumnId) {
        return props.filterSourceColumns
            .map((fsc) => fsc.filterSourceColumn)
            .find((c) => c.id === parseInt(selectedFilterSourceColumnId, 10));
    }
    function getFilterOperatorChoices(
    // @ts-expect-error - TS7006 - Parameter 'selectedFilterSourceColumn' implicitly has an 'any' type.
    selectedFilterSourceColumn) {
        let choices = [];
        switch (selectedFilterSourceColumn.filterFieldType) {
            case FilterFieldType.TEXT:
                choices = [
                    filterOperators.get("ILIKE"),
                    filterOperators.get("NOT_ILIKE"),
                    filterOperators.get("EQUAL"),
                    filterOperators.get("NOT_EQUAL"),
                    filterOperators.get("EMPTY"),
                    filterOperators.get("NOT_EMPTY"),
                ];
                break;
            case FilterFieldType.NUMERIC:
                choices = [
                    filterOperators.get("LESS_THAN"),
                    filterOperators.get("LESS_THAN_OR_EQUAL"),
                    filterOperators.get("GREATER_THAN"),
                    filterOperators.get("GREATER_THAN_OR_EQUAL"),
                    filterOperators.get("EQUAL"),
                    filterOperators.get("NOT_EQUAL"),
                    filterOperators.get("EMPTY"),
                    filterOperators.get("NOT_EMPTY"),
                ];
                break;
            case FilterFieldType.DATE:
            case FilterFieldType.DATE_AND_TIME:
                choices = [
                    filterOperators.get("BEFORE"),
                    filterOperators.get("AFTER"),
                    filterOperators.get("EQUAL"),
                    filterOperators.get("NOT_EQUAL"),
                    filterOperators.get("EMPTY"),
                    filterOperators.get("NOT_EMPTY"),
                    filterOperators.get("LAST_YEAR"),
                    filterOperators.get("LAST_QUARTER"),
                    filterOperators.get("LAST_MONTH"),
                    filterOperators.get("LAST_WEEK"),
                    filterOperators.get("YESTERDAY"),
                    filterOperators.get("TODAY"),
                    filterOperators.get("TOMORROW"),
                    filterOperators.get("THIS_WEEK"),
                    filterOperators.get("THIS_MONTH"),
                    filterOperators.get("THIS_QUARTER"),
                    filterOperators.get("THIS_YEAR"),
                    filterOperators.get("NEXT_WEEK"),
                    filterOperators.get("NEXT_MONTH"),
                    filterOperators.get("NEXT_QUARTER"),
                    filterOperators.get("NEXT_YEAR"),
                ];
                break;
            case FilterFieldType.TAG_LOOKUP:
            case FilterFieldType.FINANCIAL_AID_INDICATOR_LOOKUP:
                choices = [
                    filterOperators.get("IN"),
                    filterOperators.get("NOT_IN"),
                    filterOperators.get("EMPTY"),
                    filterOperators.get("NOT_EMPTY"),
                    filterOperators.get("ALL"),
                ];
                break;
            case FilterFieldType.PROGRAM_LOOKUP:
            case FilterFieldType.HOLD_LOOKUP:
            case FilterFieldType.LOCATION_LOOKUP:
            case FilterFieldType.ACADEMIC_CALENDAR_LOOKUP:
            case FilterFieldType.COURSE_LOOKUP:
            case FilterFieldType.DEGREE_LOOKUP:
            case FilterFieldType.ALERT_TYPE_LOOKUP:
            case FilterFieldType.PERSON_LOOKUP:
            case FilterFieldType.NOTE_TYPE_LOOKUP:
            case FilterFieldType.SERVICE_DELIVERY_LOCATION_LOOKUP:
            case FilterFieldType.SERVICE_OFFERING_LOOKUP:
            case FilterFieldType.ATTENDANCE_STATUS_LOOKUP:
            case FilterFieldType.ACHIEVEMENT_TYPE_LOOKUP:
            case FilterFieldType.DELIVERY_METHOD_LOOKUP:
            case FilterFieldType.MESSAGE_PRIORITY_LOOKUP:
            case FilterFieldType.MESSAGE_TEMPLATE_LOOKUP:
            case FilterFieldType.DELIVERY_STATUS_LOOKUP:
            case FilterFieldType.MESSAGE_DELIVERY_EXCEPTION_LOOKUP:
            case FilterFieldType.MAJOR_LOOKUP:
            case FilterFieldType.RISK_LEVEL:
            case FilterFieldType.TRANSCRIPT_COURSE_STATUS_LOOKUP:
            case FilterFieldType.INTENT_LOOKUP:
            case FilterFieldType.ETHNICITY_LOOKUP:
            case FilterFieldType.RACE_LOOKUP:
            case FilterFieldType.ROLE_LOOKUP:
            case FilterFieldType.COURSE_SECTION_STATUS_LOOKUP:
            case FilterFieldType.ACADEMIC_TERM_LOOKUP:
            case FilterFieldType.TASK_STATUS_LOOKUP:
            case FilterFieldType.TASK_TEMPLATE_LOOKUP:
            case FilterFieldType.PERSON_APPLICATION_STATUS_LOOKUP:
            case FilterFieldType.MEETING_TYPE_LOOKUP:
            case FilterFieldType.MEETING_MODALITY_LOOKUP:
            case FilterFieldType.TASK_PRIORITY_LOOKUP:
            case FilterFieldType.ACADEMIC_PLAN_STATUS_LOOKUP:
            case FilterFieldType.ACADEMIC_PLAN_TEMPLATE_LOOKUP:
            case FilterFieldType.RESOURCE_CATEGORY_LOOKUP:
            case FilterFieldType.STATE_LOOKUP:
            case FilterFieldType.RESOURCE_VISIBILITY_LOOKUP:
            case FilterFieldType.SURVEY_RESPONSE_STATUS_LOOKUP:
            case FilterFieldType.SURVEY_LOOKUP:
            case FilterFieldType.OUTREACH_LOOKUP:
            case FilterFieldType.GENDER_LOOKUP:
            case FilterFieldType.ENGAGEMENT_TYPE_LOOKUP:
            case FilterFieldType.VIRTUALIZED_APP_LOOKUP:
            case FilterFieldType.PERSON_TYPE_LOOKUP:
            case FilterFieldType.ACADEMIC_PLAN_TERM_STATUS:
            case FilterFieldType.ADMIT_STATUS_LOOKUP:
            case FilterFieldType.RESIDENCY_STATUS_LOOKUP:
            case FilterFieldType.STUDENT_LOAD_INTENT_LOOKUP:
            case FilterFieldType.AREA_OF_STUDY_LOOKUP:
            case FilterFieldType.AREA_OF_STUDY_MAJOR_LOOKUP:
            case FilterFieldType.MINOR_LOOKUP:
            case FilterFieldType.CONCENTRATIONS_LOOKUP:
            case FilterFieldType.HIGH_SCHOOL_GRADUATION_TYPE_LOOKUP:
            case FilterFieldType.HIGH_SCHOOL_TRANSCRIPT_STATUS_LOOKUP:
            case FilterFieldType.HIGH_SCHOOL_TRANSCRIPT_TYPE_LOOKUP:
            case FilterFieldType.STUDENT_TYPE_LOOKUP:
            case FilterFieldType.HIGH_SCHOOL_LOOKUP:
            case FilterFieldType.INSTITUTION_TRANSCRIPT_COURSE_STATUS_LOOKUP:
            case FilterFieldType.VETERAN_TYPE_LOOKUP:
            case FilterFieldType.TERM_ATTENDANCE_STATUS_LOOKUP:
            case FilterFieldType.MEETING_STATUS_LOOKUP:
                choices = [
                    filterOperators.get("IN"),
                    filterOperators.get("NOT_IN"),
                    filterOperators.get("EMPTY"),
                    filterOperators.get("NOT_EMPTY"),
                ];
                break;
            case FilterFieldType.COURSE_SECTION_LOOKUP:
                choices = [filterOperators.get("IN"), filterOperators.get("NOT_IN")];
                break;
            case FilterFieldType.BOOLEAN:
                choices = [
                    filterOperators.get("EQUAL"),
                    filterOperators.get("EMPTY"),
                    filterOperators.get("NOT_EMPTY"),
                ];
                break;
            // TODO: all the other options
            default:
                choices = [];
        }
        return choices;
    }
    function renderOperatorSelector() {
        if (!props.selectedFilterSourceColumnId) {
            return (_jsx("select", { className: "form-control", value: "", 
                // @ts-expect-error - TS2322 - Type '{ children: Element; className: string; value: string; readOnly: true; "aria-label": string; }' is not assignable to type 'DetailedHTMLProps<SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement>'.
                readOnly: true, "aria-label": "Filter operator", children: _jsx("option", { value: "", disabled: true, children: "Operator" }, "chooseanoperator") }));
        }
        const selectedFilterSourceColumn = getSelectedFilterSourceColumn(props.selectedFilterSourceColumnId);
        if (!selectedFilterSourceColumn) {
            return _jsx("span", { children: "choose a column" });
        }
        // TODO: based on the column type, render an appropriate selection of operators.
        // TODO: incorporate lookups for each field as necessary, etc.
        // prettier-ignore
        const choices = getFilterOperatorChoices(selectedFilterSourceColumn);
        return (_jsxs("select", { className: "form-control", onChange: (event) => onOperatorChangedInternal(event), value: props.selectedOperatorName, "aria-label": "Filter operator", children: [_jsx("option", { value: "", disabled: true, children: "Operator" }, "chooseanoperator"), choices.map((c) => c ? (_jsx("option", { value: c.name, children: c.displayName }, c.value)) : (""))] }));
    }
    function renderValueEntry() {
        const selectedFilterSourceColumn = getSelectedFilterSourceColumn(props.selectedFilterSourceColumnId);
        if (!selectedFilterSourceColumn) {
            return (_jsx("input", { type: "text", className: "form-control", "aria-label": "Filter condition value", readOnly: true, disabled: true }));
        }
        if (isArgumentlessOperator(props.selectedOperatorName)) {
            return "";
        }
        return (_jsx(FilterConditionValueEntry, { filterSourceColumn: selectedFilterSourceColumn, onValueChange: (value, displayValue) => {
                // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
                props.onValueChange(value, displayValue);
            }, onValueTypeChange: (value) => {
                props.onValueTypeChange(value);
            }, value: props.value, valueType: props.valueType, relativeOption: props.relativeOption, onRelativeOptionChange: (relativeOption) => {
                props.onRelativeOptionChange(relativeOption);
            } }));
    }
    const [confirmation, confirmModals] = useConfirmation();
    const [isConfirming, setIsConfirming] = React.useState(false);
    return (_jsxs(_Fragment, { children: [confirmModals, _jsxs("div", { className: "row mb-1", children: [_jsx("div", { className: "col-3", children: _jsx(FilterColumnSelector, { filterSourceColumns: props.filterSourceColumns.filter((c) => c.filterSourceColumn.canFilter &&
                                c.filterSourceColumn.filterFieldType !== null), onChange: (selectedFilterSourceColumnId, selectedFilterSourceRelationshipId) => {
                                var _a;
                                // prettier-ignore
                                const choices = getFilterOperatorChoices(getSelectedFilterSourceColumn(selectedFilterSourceColumnId));
                                let newOperator = "";
                                if ((choices === null || choices === void 0 ? void 0 : choices.length) > 0) {
                                    // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
                                    newOperator = (_a = choices[0]) === null || _a === void 0 ? void 0 : _a.name;
                                }
                                props.onFilterConditionColumnChange(selectedFilterSourceColumnId, selectedFilterSourceRelationshipId, newOperator);
                            }, selectedFilterSourceColumnId: props.selectedFilterSourceColumnId, selectedFilterSourceRelationshipId: props.selectedFilterSourceRelationshipId }) }), _jsx("div", { className: "col-3", children: renderOperatorSelector() }), _jsx("div", { className: "col-4", children: renderValueEntry() }), _jsx("div", { className: "col-auto d-flex align-items-center", children: !isArgumentlessOperator(props.selectedOperatorName) && (_jsxs("div", { className: "custom-control custom-checkbox", children: [_jsx("input", { id: `chkPrompt_${props.filterConditionId}`, type: "checkbox", className: "custom-control-input", checked: props.isPrompt, onChange: (event) => props.isPromptChanged(event.target.checked) }), _jsx("label", { htmlFor: `chkPrompt_${props.filterConditionId}`, className: "custom-control-label", children: "Prompt" })] })) }), _jsx("div", { className: "col-auto d-flex align-items-center", children: _jsxs("button", { disabled: isConfirming, className: "btn btn-link empty-btn-link", onClick: () => {
                                var _a;
                                // Make sure the user wants to remove the column if it's deprecated
                                if ((_a = getSelectedFilterSourceColumn(props.selectedFilterSourceColumnId)) === null || _a === void 0 ? void 0 : _a.deprecated) {
                                    setIsConfirming(true);
                                    confirmation(_jsxs(_Fragment, { children: [_jsx("div", { children: "Are you sure you want to remove this column?" }), _jsx("div", { children: "After removing it you won't be able to add it back." })] }))
                                        .then((yes) => {
                                        if (yes) {
                                            props.onRemoveClick();
                                        }
                                    })
                                        .finally(() => {
                                        setIsConfirming(false);
                                    });
                                }
                                else {
                                    props.onRemoveClick();
                                }
                            }, type: "button", children: [_jsx("span", { className: "fa fa-lg fa-times text-danger", "aria-hidden": "true", "aria-label": "Remove Filter", title: "Remove Filter" }), _jsx("span", { className: "sr-only", children: "Remove Filter" })] }) }), ((_a = getSelectedFilterSourceColumn(props.selectedFilterSourceColumnId)) === null || _a === void 0 ? void 0 : _a.deprecated) && (_jsx("span", { className: "col-auto d-flex align-items-center my-2", "data-toggle": "tooltip", title: "WARNING: The selected filter is being phased out. After removing it from this report source and saving,\n        you will no longer be able to add it back.", children: _jsx(StatusBadge, { badgeColor: "warning", statusName: "Being Removed" }) }))] })] }));
};
export default FilterConditionComponent;
